<template>
  <div class="nav-tabs-custom">
    <ul class="nav nav-tabs">
      <template v-for="(tab, index) in tabs">
        <li :key="index" class="nav-item" :class="{ 'nav-item-danger': tab.icon && tab.icon.includes('nav-danger') }">
          <a @click="changeTab(index + 1)" class="nav-link" :class="{ 'active' : (index + 1) === activeTab }">
            <span class="fa fa-fw" :class="tab.icon"></span> {{ tab.title }}
          </a>
        </li>
      </template>
    </ul>
    <div class="tab-content">
      <template v-for="n in tabCount">
        <div :key="n" class="tab-pane" :class="{ 'active' : n === activeTab }">
          <slot :name="`tab${n}`"></slot>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavTab',
  props: {
    tabCount: {
      type: Number,
      default () {
        return 1
      }
    }
  },
  data () {
    return {
      activeTab: 1,
      tabs: [
        { title: 'Tab 1', name: 'tab1' }
      ]
    }
  },
  watch: {
    $route () {
      if (this.$route.hash) {
        let hash = this.$route.hash
        let selectedTab = this.tabs.findIndex((el) => hash.includes(el.name)) + 1
        if (selectedTab) {
          if (this.activeTab !== selectedTab) this.changeTab(selectedTab)
        }
      }
    }
  },
  mounted () {
    this.refreshTabs()
  },
  methods: {
    changeTab (tab) {
      this.activeTab = tab
      if (window.history.state) {
        window.history.replaceState(window.history.state, this.tabs[tab - 1].title, '#tab' + tab)
      } else {
        window.history.replaceState({}, this.tabs[tab - 1].title, '#tab' + tab)
      }
      this.$emit('change', tab)
    },
    refreshTabs (tab) {
      let tabs = []
      for (let name in this.$slots) {
        let el = this.$slots[name][0].elm
        tabs.push({
          title: el.attributes.title.value,
          name,
          icon: el.attributes.icon.value
        })
      }
      this.tabs = tabs
      if (this.$route.hash) {
        let hash = this.$route.hash
        let selectedTab = this.tabs.findIndex((el) => hash.includes(el.name)) + 1
        if (selectedTab) this.changeTab(selectedTab)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NavTab.vue